export default __webpack_public_path__ + "static/media/meteor.808a091b.svg";